import { defaultFilterableOptions } from '../../core/default-filterable-options';
import { defaultSortableOption } from '../../core/pageable-options';
import { LOAD_STATES } from '../common';
import { externalApplications as externalAppFixtures } from '../../stubs/external-applications';
import { AmplifyCore } from '@codametrix/ui-common';
import { formErrors } from '../../stubs/form-errors';
const { paginationUtils } = AmplifyCore;
const externalAppsListPath = {
    displayName: 'External Applications',
    path: '/cmx/admin/orgs/:orgId(\\d+)/external-applications/'
};
const externalAppDetailPath = {
    displayName: 'External Applications',
    path: '/cmx/admin/orgs/:orgId(\\d+)/external-applications/:externalApp/',
    getDisplayName: (state)=>{
        const { externalApplications: selectedExternalApplication } = state;
        return selectedExternalApplication.selectedExternalApplication.externalApplicationName;
    }
};
const externalAppUserForm = {
    displayName: 'User Form',
    path: '/cmx/admin/orgs/:orgId(\\d+)/external-applications/:externalApp/users/:form',
    getDisplayName: (state)=>{
        const { externalApplications: { selectedUser } } = state;
        const displayName = selectedUser.username.length ? `Edit` : `Add`;
        return displayName;
    }
};
export const externalAppPaths = [
    externalAppsListPath,
    externalAppDetailPath,
    externalAppUserForm
];
const sortablePageable = {
    pageableDefinition: {
        ...paginationUtils.emptyPageable
    },
    sortableOptions: [
        {
            ...defaultSortableOption
        }
    ],
    filterableOptions: defaultFilterableOptions
};
const appColumnDefs = [
    {
        key: 'externalApplicationName',
        displayName: 'Name',
        transform: (data)=>{
            const { externalApplicationName } = data;
            return externalApplicationName;
        }
    },
    {
        key: 'organizationName',
        displayName: 'Organization Name',
        transform: (data)=>{
            const { organizationName } = data;
            return organizationName;
        }
    },
    {
        key: 'isActive',
        displayName: 'Active',
        transform: (data)=>{
            const { isActive } = data;
            return isActive?.toString() ?? '';
        }
    }
];
const userColumnDefs = [
    {
        key: 'username',
        displayName: 'Username'
    },
    {
        key: 'alias',
        displayName: 'alias'
    }
];
export const externalApplications = {
    externalApplicationList: {
        loadState: LOAD_STATES.done,
        columnDefs: appColumnDefs,
        label: 'External Application',
        itemName: 'External Applications',
        sortablePageable
    },
    externalApplicationUserList: {
        loadState: LOAD_STATES.done,
        columnDefs: userColumnDefs,
        label: 'External Application Users',
        itemName: 'External Application Users',
        sortablePageable
    },
    selectedExternalApplication: externalAppFixtures.defaultExternalApplication,
    selectedUser: externalAppFixtures.defaultExternalApplicationUser,
    selectedOrgId: undefined,
    userFormErrors: formErrors.noErrors
};
